export default "__VITE_ASSET__D4znR03P__"